Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Instagram", {
  enumerable: true,
  get: function get() {
    return _instagram.Instagram;
  }
});
var _instagram = require("./instagram");